import React, { useState, useRef, useEffect, useContext } from 'react';
import './AvatarDisplay.css';
import MyAvatarSelection from '../../basic/MyAvatarSelection';
import placeholderAvatar from '../../../assets/Avatars/placeholder/placeholder.png';
import { updateFamilyMemberDetails } from '../../../api';
import { FamilyContext } from '../../../context/FamilyContext';

const avatarContext = require.context('../../../assets/Avatars', false, /\.(png|jpe?g|svg)$/);
const avatars = Object.fromEntries(
  avatarContext.keys().map(key => [key.replace('./', ''), avatarContext(key)])
);

function AvatarDisplay({ imageUrl, childName, childId }) {
    const [isHovered, setIsHovered] = useState(false);
    const [showSelection, setShowSelection] = useState(false);
    const avatarRef = useRef(null);
    const { refetchFamilyData } = useContext(FamilyContext);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (avatarRef.current && !avatarRef.current.contains(event.target)) {
                setShowSelection(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleAvatarClick = (e) => {
        e.stopPropagation();
        setShowSelection(prev => !prev);
    };

    const handleSelectAvatar = async (newAvatarUrl) => {
        try {
            await updateFamilyMemberDetails(childId, { avatar_url: newAvatarUrl });
            setShowSelection(false);
            // Refetch family data to update the context
            await refetchFamilyData();
        } catch (error) {
            console.error('Failed to update avatar:', error);
            // Optionally, you can add some user feedback here, like showing an error message
        }
    };

    return (
        <div style={{ textAlign: 'center', position: 'relative' }} ref={avatarRef}>
            <div 
                className="avatar-display" 
                style={{
                    backgroundImage: `url(${imageUrl ? (avatars[imageUrl] || placeholderAvatar) : placeholderAvatar})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    margin: 'auto',
                    position: 'relative',
                    cursor: 'pointer'
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleAvatarClick}
            >
                {isHovered && (
                    <div className="edit-overlay">
                        <span className="edit-icon"></span>
                    </div>
                )}
            </div>
            {showSelection && (
                <div className="avatar-selection-tooltip">
                    <MyAvatarSelection
                        currentAvatar={imageUrl || 'placeholder.png'}
                        onSelectAvatar={handleSelectAvatar}
                    />
                </div>
            )}
            <h3 style={{ marginTop: '10px' }}>{childName}</h3>  
        </div>
    );
}

export default AvatarDisplay;